import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { ChecklistQuestionGroup } from '../../interfaces/checklists-question.interface';

@Component({
  selector: 'bizz-checklist-groups',
  standalone: true,
  imports: [
    IconComponent,
    DropDownsModule
  ],
  templateUrl: './checklist-groups.component.html',
  styleUrl: './checklist-groups.component.scss'
})
export class ChecklistGroupsComponent {
  @Input({required: true}) public groups: { group: ChecklistQuestionGroup, questions: number[], checkedQuestions: number }[];
  @Input() public selectedGroup: { group: ChecklistQuestionGroup, questions: number[], checkedQuestions: number } | null;
  @Output() public groupChanged = new EventEmitter();
  @Input() public show: boolean = false;
  @Input() public isMobileView: boolean = false;

  public onGroupChanged(group: any): void {
    this.selectedGroup = group;
    this.groupChanged.emit(this.selectedGroup);
  } 
  
}
